import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { VIDEO_SOURCES } from '@wix/wix-vod-constants/common';
import { Vimeo } from './external/vimeo';
import { Youtube } from './external/youtube';
import { Facebook } from './external/facebook';
const fullScreenChangeEventsList = [
    'fullscreenchange',
    'mozfullscreenchange',
    'webkitfullscreenchange',
    'msfullscreenchange',
];
export class ExternalPlayer extends React.Component {
    constructor() {
        super(...arguments);
        this.handleFullscreenChange = () => {
            this.props.onFullScreenChanged(this.isInFullScreen);
        };
    }
    UNSAFE_componentWillMount() {
        if (typeof document !== 'undefined') {
            this.addFullscreenEventHandler();
        }
    }
    componentWillUnmount() {
        this.removeFullscreenEventHandler();
    }
    get isInFullScreen() {
        return Boolean(document.fullscreenElement ||
            document.mozFullScreenElement ||
            document.webkitFullscreenElement ||
            document.msFullscreenElement);
    }
    addFullscreenEventHandler() {
        _.forEach(fullScreenChangeEventsList, (eventName) => document.addEventListener(eventName, this.handleFullscreenChange));
    }
    removeFullscreenEventHandler() {
        _.forEach(fullScreenChangeEventsList, (eventName) => document.removeEventListener(eventName, this.handleFullscreenChange));
    }
    render() {
        const { locale, videoItem, isVideoPlayRequested, isVideoPauseRequested, isVideoPlaying, isVideoPaused, onPlay, onPause, onEnded, onIframeRef, onVolumeChange, fillAllSpace, YoutubePlayer = Youtube, } = this.props;
        if (!videoItem) {
            return null;
        }
        const { id, externalId, mediaExternUrl, videoSource } = videoItem;
        const playersMap = {
            [VIDEO_SOURCES.YOUTUBE]: YoutubePlayer,
            [VIDEO_SOURCES.VIMEO]: Vimeo,
            [VIDEO_SOURCES.FACEBOOK]: Facebook,
        };
        const Player = playersMap[videoSource];
        if (!Player) {
            return null;
        }
        return (React.createElement(Player, { ...this.props, fillAllSpace: fillAllSpace, locale: locale, key: id || externalId, showControls: true, isVideoPlayRequested: isVideoPlayRequested, isVideoPauseRequested: isVideoPauseRequested, isVideoPlaying: isVideoPlaying, isVideoPaused: isVideoPaused, src: mediaExternUrl, onPlay: onPlay, onPause: onPause, onEnd: onEnded, onVolumeChange: onVolumeChange, onIframeRef: onIframeRef }));
    }
}
ExternalPlayer.propTypes = {
    compId: PropTypes.string,
    isVideoPlayRequested: PropTypes.bool,
    isVideoPauseRequested: PropTypes.bool,
    isVideoPlaying: PropTypes.bool,
    isVideoPaused: PropTypes.bool,
    muted: PropTypes.bool,
    fillAllSpace: PropTypes.bool,
    onPlay: PropTypes.func,
    onPause: PropTypes.func,
    onEnded: PropTypes.func,
    onVolumeChange: PropTypes.func,
    onIframeRef: PropTypes.func,
    onFullScreenChanged: PropTypes.func,
    onLoad: PropTypes.func,
    onPlayBlocked: PropTypes.func,
    videoItem: PropTypes.object.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
    locale: PropTypes.string,
    YoutubePlayer: PropTypes.elementType,
};
ExternalPlayer.defaultProps = {
    onPlay: _.noop,
    onPause: _.noop,
    onEnded: _.noop,
    onLoad: _.noop,
    onPlayBlocked: _.noop,
    onError: _.noop,
    onFullScreenChanged: _.noop,
    onIframeRef: _.noop,
    onVolumeChange: _.noop,
};
//# sourceMappingURL=player-external.js.map